<template>
  <v-card class="mr-3 ml-3 mb-3 pa-3">
    <v-card-title class="headline">Добавление Пользователя</v-card-title>
    <v-card-text>
      <v-form v-model="isValid" ref="form">
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field label="Фамилия Имя (Отчество)"
                          v-model="user.fullName"
                          :rules="[notEmptyRule]"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field label="Телефон"
                          v-model="user.phone"
                          :rules="[notEmptyRule, length50]"
                          counter="50"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field label="Email"
                          v-model="user.email"
                          :rules="[notEmptyRule, emailIsUnique, emailRule]"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field label="Пароль"
                          v-model="user.password"
                          :rules="[notEmptyRule]"
            >
              <template v-slot:append>
                <v-btn text x-small
                       @click="user.password = generatePassword()"
                >
                  Случайный
                </v-btn>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="6">
            <v-autocomplete
                v-model="user.dealer"
                :items="choices.dealers"
                label="Дилер"
                no-data-text="Дилер не найден"
                :rules="[notEmptyRule]"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6">
            <v-select
                v-model="user.role"
                :items="choices.roles"
                label="Роль"
                :rules="[roleIsSet]"
            ></v-select>
          </v-col>

          <v-col cols="12" sm="6">
            <v-switch
                v-model="user.receiveEmails"
                label="Получать рассылку"
                hint="Предупреждение (за 10 дней) об окончании лицензии на почту"
                persistent-hint
            >
            </v-switch>
          </v-col>

          <v-col cols="12" sm="6">
            <v-switch
                v-model="user.sendNotification"
                label="Уведомить на почту"
                hint="Пользователь получит письмо на указанный Email"
                persistent-hint
            ></v-switch>
          </v-col>

          <v-col cols="12" sm="6" v-if="canManageSystemUser">
            <v-switch
                v-model="user.isSystemUser"
                label="Системный пользователь"
                hint="Пользователь для системных задач"
                persistent-hint
            ></v-switch>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary darken-1" text @click="createUser"
             :disabled="!isValid">Добавить
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import API from "@/axios/api";

export default {
  name: 'UserCreate',
  data() {
    return {
      user: {
        password: '',
        sendNotification: true,
        isSystemUser: false,
      },
      choices: {
        dealers: [],
        roles: [],
      },
      takenEmails: [],
      isValid: false,
      notEmptyRule: v => !!v || 'Поле не может быть пустым',
      roleIsSet: v => v >= 0 || 'Не указана роль',
      emailIsUnique: v => (v && !this.takenEmails.includes(v)) || 'Этот Email уже занят',
      emailRule: v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(v) || 'Неверный формат email',
      length50: v => (v && v.length <= 50) || 'Максимум 50 символов',
    }
  },
  methods: {
    generatePassword() {
      return Array(10)
          .fill('0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz!@#$')
          .map(x => x[Math.floor(crypto.getRandomValues(new Uint32Array(1))[0] / (0xffffffff + 1) * x.length)])
          .join('');
    },
    getDealerChoices() {
      API.get('dealers/choices')
          .then((response) => {
            console.log(response.data);
            this.choices.dealers = response.data.choices;
          })
          .catch((error) => {
            console.log(error);
          });
    },
    getRoleChoices() {
      API.get('users/roles/choices')
          .then((response) => {
            console.log(response.data);
            this.choices.roles = response.data.choices;
          })
          .catch((error) => {
            console.log(error);
          });
    },
    getTakenEmails() {
      API.get('users/emails')
          .then((response) => {
            console.log(response.data);
            this.takenEmails = response.data.emails;
          })
          .catch((error) => {
            console.log(error);
          });
    },
    createUser() {
      API.post('users/create', this.user)
          .then((response) => {
            console.log(response.data);
            this.$store.commit('showSnackbar', {
              color: 'success',
              text: 'Пользователь добавлен',
            })
            // this.$refs.form.reset();
            this.$store.dispatch('updateUsers');
            this.$router.push('/users');
          })
          .catch((error) => {
            console.log(error);
            this.$store.commit('showSnackbar', {
              color: 'error',
              text: 'Пользователь не добавлен',
            })
          });
    },
  },
  computed: {
    canManageSystemUser() {
      return this.$store.getters.user.roleId === 0;
    },
  },
  created() {
    this.$store.commit('setCrumbs', [
      {text: 'main', disabled: false, to: '/', exact: true},
      {text: 'users', disabled: false, to: '/users', exact: true},
      {text: 'add', disabled: true},
    ])
    this.getDealerChoices();
    this.getRoleChoices();
    this.getTakenEmails();
  },
}
</script>